import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { List, Map, fromJS } from 'immutable';

import { AlreadyLoginPage } from 'pages';
import { Faq } from 'components';

class CtFaq extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDetailOpen: List([]),
      searchTextChange: '',
      searchText: ''
    };

    this.onKeyPressSearch = this.onKeyPressSearch.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  onMovePage = path => {
    this.setState({ isDetailOpen: List([]) });
    this.props.history.push('/intro/faq/' + path);
  };

  onDetailAnswer = answerType => {
    const array = this.state.isDetailOpen;
    const index = array.indexOf(answerType);

    // (삭제) 상세 닫기
    if (index !== -1) {
      this.setState({ isDetailOpen: array.splice(index, 1) });
      // (추가) 상세 열기
    } else {
      this.setState({ isDetailOpen: array.push(answerType) });
    }
  };

  // 검색 input 변경
  onKeyPressSearch = (e, inner, detail) => {
    this.setState({ searchTextChange: e.target.value });
    if (e.key === 'Enter') {
      this.setState({ searchText: e.target.value });
      this.props.history.push(!!inner ? '/intro/faq/' + inner : '/intro/faq/all');
    }
  };

  // 검색
  onSearch = (e, inner, detail) => {
    this.setState({ searchText: this.state.searchTextChange });
    this.props.history.push(!!inner ? '/intro/faq/' + inner : '/intro/faq/all');
  };

  render() {
    const { isAuth, location, history } = this.props;
    // function
    const { onMovePage, onDetailAnswer } = this;
    // 검색
    const { onKeyPressSearch, onSearch } = this;
    //
    const { inner, detail } = this.props.match.params;

    // if (isAuth === 1) {
    //   // 이미 로그인 된 상태로 접속
    //   if (this.state.alreadLogin) {
    //     // 만약 로그인 된 상태에서 root로 넘어왔을경우 main으로 이동
    //     if (location.pathname !== '/intro') {
    //       const toPath = location.pathname === '/' ? '/main' : location.pathname;
    //       return <Redirect to={toPath} />;
    //     }

    //     return <AlreadyLoginPage accessLevel={1} />;
    //   }
    // }

    // // 로그인 안된 상태에서 root로 들어온 경우 url을 변경해준다.
    // if (location.pathname !== '/intro') {
    //   history.replace('/intro');
    // }

    return (
      <Faq
        inner={inner}
        detail={detail}
        isDetailOpen={this.state.isDetailOpen}
        onMovePage={onMovePage}
        onDetailAnswer={onDetailAnswer}
        // 검색
        searchText={this.state.searchText}
        onKeyPressSearch={onKeyPressSearch}
        onSearch={onSearch}
      />
    );
  }
}

const mapStateToProps = state => ({
  isAuth: state.user.get('isAuth')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CtFaq);



// WEBPACK FOOTER //
// ./src/script/containers/intro/CtFaq.js